module.exports = __webpack_public_path__ + "static/media/gk_com_1.20128866.jpg";